/* PERDAH motor — onaylı ana sayfa davranışları.
   GSAP/ScrollTrigger/Lenis CDN'den yüklenir (theme.liquid).
   Her davranış kendi bölümü sayfada varsa çalışır; yoksa sessizce atlanır.
   Tema editöründe bölüm yeniden yüklenince kendini tazeler. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = matchMedia('(pointer: coarse)').matches;
  var hasGsap = !!(window.gsap && window.ScrollTrigger);
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);
  if (!hasGsap || reduce) document.documentElement.classList.remove('pd-js');

  /* ---------- Lenis smooth scroll (bir kez) ---------- */
  var lenis = null;
  if (hasGsap && !reduce && window.Lenis && !window.__pdLenis) {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    window.__pdLenis = lenis;
  } else { lenis = window.__pdLenis || null; }

  /* ---------- Global kaplama: ilerleme + imleç + damga (bir kez) ---------- */
  function globalOverlay() {
    if (window.__pdOverlay) return; window.__pdOverlay = true;
    if (!document.querySelector('.pd-o')) return;
    var frag = document.createElement('div');
    frag.innerHTML = '<div id="pdProg"></div>';
    while (frag.firstChild) document.body.appendChild(frag.firstChild);
    if (!hasGsap || reduce) { var p = document.getElementById('pdProg'); if (p) p.style.display = 'none'; return; }
    gsap.to('#pdProg', { scaleX: 1, ease: 'none', scrollTrigger: { start: 0, end: 'max', scrub: 0.3 } });
  }

  /* ---------- Yardımcılar ---------- */
  function once(el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function revealAll(scope) {
    (scope || document).querySelectorAll('[data-pd-reveal]').forEach(function (el) { el.style.opacity = ''; el.style.transform = ''; });
  }
  function reveal(scope) {
    if (!hasGsap || reduce) return revealAll(scope);
    (scope || document).querySelectorAll('[data-pd-reveal]').forEach(function (el) {
      if (!once(el, 'pdRv')) return;
      gsap.to(el, { y: 0, autoAlpha: 1, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 84%', once: true } });
    });
  }

  /* ---------- HERO ---------- */
  function initHero(scope) {
    (scope || document).querySelectorAll('.xhero').forEach(function (hero) {
      if (!once(hero, 'pdInit')) return;
      if (!hasGsap || reduce) return;
      var tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
      tl.to(hero.querySelectorAll('.xh-title .li'), { yPercent: 0, y: 0, autoAlpha: 1, duration: 1.15, stagger: 0.14 }, 0.1)
        .to(hero.querySelectorAll('.xp--tile .ph, .xp--free img'), { y: 0, autoAlpha: 1, duration: 1.1, stagger: 0.1 }, 0.35)
        .to(hero.querySelectorAll('.xp-cap'), { y: 0, autoAlpha: 1, duration: 0.6, stagger: 0.08, clearProps: 'all' }, 0.6)
        .to(hero.querySelectorAll('.xh-cta'), { y: 0, autoAlpha: 1, duration: 0.7 }, 0.8);
      if (hero.dataset.parallax === 'true') {
        hero.querySelectorAll('.xp--tile .ph').forEach(function (ph, i) {
          gsap.set(ph, { rotation: parseFloat(ph.dataset.rot || (i === 0 ? -2.5 : 2.5)) });
          gsap.to(ph, { yPercent: i === 0 ? -13 : -9, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        });
        var free = hero.querySelector('.xp--free img');
        if (free) gsap.to(free, { yPercent: -24, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        gsap.to(hero.querySelector('.xh-title'), { yPercent: -26, autoAlpha: 0.14, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      }
    });
  }

  /* ---------- KEMERLER: mobil ray + otomatik döngü ---------- */
  function initKemer(scope) {
    (scope || document).querySelectorAll('.htrack').forEach(function (rail) {
      if (!once(rail, 'pdInit')) return;
      var wrap = rail.closest('.pd-o');
      var prev = wrap.querySelector('.hbtn2--prev'), next = wrap.querySelector('.hbtn2--next'), prog = wrap.querySelector('.hnav .cnt');
      var n = rail.querySelectorAll('.hp').length;
      function w() { var c = rail.querySelector('.hp'); return c ? c.getBoundingClientRect().width + 14 : 300; }
      function max() { return rail.scrollWidth - rail.clientWidth; }
      function upd() { if (!prog) return; var i = Math.round(rail.scrollLeft / w()) + 1; i = Math.max(1, Math.min(n, i)); prog.textContent = '0' + i + ' / 0' + n; }
      rail.addEventListener('scroll', upd, { passive: true }); upd();
      var pause = false, seen = true, timer = null;
      var auto = parseInt(rail.dataset.auto || '0', 10) * 1000;
      function step() {
        if (pause || !seen || max() < 10) return;
        if (rail.scrollLeft >= max() - 8) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: w(), behavior: 'smooth' });
      }
      function arm() { if (!auto || reduce) return; clearInterval(timer); timer = setInterval(step, auto); }
      prev && prev.addEventListener('click', function () { rail.scrollBy({ left: -w(), behavior: 'smooth' }); arm(); });
      next && next.addEventListener('click', function () { rail.scrollBy({ left: w(), behavior: 'smooth' }); arm(); });
      rail.addEventListener('pointerenter', function () { pause = true; });
      rail.addEventListener('pointerleave', function () { pause = false; });
      rail.addEventListener('touchstart', function () { pause = true; clearInterval(timer); setTimeout(function () { pause = false; arm(); }, 8000); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.25 }).observe(rail);
      arm();
      drag(rail);
    });
  }

  function drag(rail) {
    var down = false, sx = 0, sl = 0;
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; sx = e.clientX; sl = rail.scrollLeft; rail.classList.add('drag'); });
    addEventListener('pointermove', function (e) { if (!down) return; rail.scrollLeft = sl - (e.clientX - sx); });
    addEventListener('pointerup', function () { down = false; rail.classList.remove('drag'); });
  }

  /* ---------- VİTRİN rayı ---------- */
  function initVitrin(scope) {
    (scope || document).querySelectorAll('.frail').forEach(function (fr) {
      if (!once(fr, 'pdInit')) return;
      drag(fr);
      var pause = false, seen = true, timer = null, down = false;
      var auto = parseInt(fr.dataset.auto || '0', 10) * 1000;
      function w() { var c = fr.querySelector('.fc'); return c ? c.getBoundingClientRect().width + 16 : 316; }
      function max() { return fr.scrollWidth - fr.clientWidth; }
      function step() {
        if (pause || !seen || max() < 10) return;
        if (fr.scrollLeft >= max() - 8) fr.scrollTo({ left: 0, behavior: 'smooth' });
        else fr.scrollBy({ left: w(), behavior: 'smooth' });
      }
      function arm() { if (!auto || reduce) return; clearInterval(timer); timer = setInterval(step, auto); }
      fr.addEventListener('pointerenter', function () { pause = true; });
      fr.addEventListener('pointerleave', function () { pause = false; });
      fr.addEventListener('touchstart', function () { pause = true; clearInterval(timer); setTimeout(function () { pause = false; arm(); }, 8000); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.25 }).observe(fr);
      arm();
    });
  }

  /* ---------- İMZA: teknik çizim ---------- */
  function initImza(scope) {
    (scope || document).querySelectorAll('.manda').forEach(function (sec) {
      if (!once(sec, 'pdInit')) return;
      var strokes = sec.querySelectorAll('.bp path, .bp line, .bp circle');
      if (!hasGsap || reduce) return;
      strokes.forEach(function (el) { el.style.strokeDasharray = '1'; el.style.strokeDashoffset = '1'; });
      gsap.to(strokes, { strokeDashoffset: 0, duration: 1.5, stagger: 0.08, ease: 'power2.out', scrollTrigger: { trigger: sec, start: 'top 70%', once: true } });
      gsap.from(sec.querySelectorAll('.bp text'), { autoAlpha: 0, duration: 0.6, delay: 1, scrollTrigger: { trigger: sec, start: 'top 70%', once: true } });
      gsap.from(sec.querySelectorAll('.mc > *'), { y: 28, autoAlpha: 0, stagger: 0.08, duration: 0.7, ease: 'power3.out', scrollTrigger: { trigger: sec, start: 'top 74%', once: true } });
      gsap.from(sec.querySelectorAll('.mduo .mp'), { y: 40, autoAlpha: 0, stagger: 0.14, duration: 0.9, ease: 'power3.out', scrollTrigger: { trigger: sec, start: 'top 78%', once: true } });
    });
  }

  /* ---------- SATIRLAR: clip açılım ---------- */
  function initSatir(scope) {
    (scope || document).querySelectorAll('.r-media').forEach(function (m) {
      if (!once(m, 'pdInit')) return;
      if (!hasGsap || reduce) return;
      var r = getComputedStyle(m).borderRadius || '24px';
      gsap.fromTo(m, { clipPath: 'inset(14% 10% 14% 10% round ' + r + ')' }, { clipPath: 'inset(0% 0% 0% 0% round ' + r + ')', ease: 'none', scrollTrigger: { trigger: m, start: 'top 88%', end: 'top 42%', scrub: 0.5 } });
      var img = m.querySelector('img');
      if (img) gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: 'none', scrollTrigger: { trigger: m, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    (scope || document).querySelectorAll('.r-txt').forEach(function (t) {
      if (!once(t, 'pdInit')) return;
      if (!hasGsap || reduce) return;
      gsap.from(t.children, { y: 30, autoAlpha: 0, stagger: 0.08, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: t, start: 'top 84%', once: true } });
    });
  }

  /* ---------- ALINTI: kelime boyama ---------- */
  function initAlinti(scope) {
    (scope || document).querySelectorAll('.quote').forEach(function (q) {
      if (!once(q, 'pdInit')) return;
      var p = q.querySelector('.qx');
      if (!p || !hasGsap || reduce || q.dataset.scrub !== 'true') return;
      p.innerHTML = p.textContent.split(' ').map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
      gsap.to(p.querySelectorAll('.w'), { color: getComputedStyle(q).getPropertyValue('--ink') || '#17130E', stagger: 0.12, ease: 'none', scrollTrigger: { trigger: q, start: 'top 78%', end: 'top 30%', scrub: 0.4 } });
      gsap.from(q.querySelectorAll('.q-cta'), { y: 24, autoAlpha: 0, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: q, start: 'top 55%', once: true } });
    });
  }

  /* ---------- KOMBİN ---------- */
  function initKombin(scope) {
    (scope || document).querySelectorAll('[data-pd-kombin]').forEach(function (wrap) {
      if (!once(wrap, 'pdInit')) return;
      var data;
      try { data = JSON.parse(wrap.querySelector('script[data-pd-kombin-data]').textContent); } catch (e) { return; }
      var card = wrap.querySelector('.look-card'), chips = wrap.querySelector('.lk-chips');
      if (!card || !chips || !data.length) return;
      function money(v) { return v.toLocaleString('tr-TR') + ' TL'; }
      function tile(x) {
        return '<div class="lk-item"><span class="lk-ph"><img src="' + x.img + '" alt="' + x.nm + '" loading="lazy"></span><b>' + x.nm + '</b><span class="pp">' + money(x.pr) + '</span></div>';
      }
      function render(i, anim) {
        var L = data[i], ayri = L.a.pr + L.b.pr, kazanc = ayri - L.bundle;
        function put() {
          card.innerHTML = '<div class="lk-grid">' + tile(L.a) + '<div class="lk-plus">+</div>' + tile(L.b)
            + '<div class="lk-div"></div>'
            + '<div class="lk-sum"><span class="ayr">' + wrap.dataset.ayrLabel + ' ' + money(ayri) + '</span>'
            + '<div class="tot">' + wrap.dataset.totLabel + ' ' + money(L.bundle) + '</div>'
            + (kazanc > 0 ? '<span class="lk-save">✦ ' + money(kazanc).replace(' TL', '') + ' TL ' + wrap.dataset.saveLabel + '</span><br>' : '<br>')
            + '<a class="pd-btn" href="' + (L.url || '#') + '">' + wrap.dataset.ctaLabel + ' <span class="ar">→</span></a>'
            + '<span class="lk-note">' + wrap.dataset.note + '</span></div></div>';
          card.classList.remove('swap');
        }
        if (anim) { card.classList.add('swap'); setTimeout(put, 320); } else put();
      }
      chips.innerHTML = data.map(function (L, i) { return '<button class="lk-chip' + (i === 0 ? ' on' : '') + '" data-i="' + i + '">' + L.tag + '</button>'; }).join('');
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('.lk-chip'); if (!b) return;
        chips.querySelectorAll('.lk-chip').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on'); render(+b.dataset.i, true);
      });
      render(0, false);
    });
  }

  /* ---------- HEDİYE SİHİRBAZI ---------- */
  function initHediye(scope) {
    (scope || document).querySelectorAll('[data-pd-hediye]').forEach(function (wrap) {
      if (!once(wrap, 'pdInit')) return;
      var cfg, gifts;
      try {
        cfg = JSON.parse(wrap.querySelector('script[data-pd-hediye-sorular]').textContent);
        gifts = JSON.parse(wrap.querySelector('script[data-pd-hediye-urunler]').textContent);
      } catch (e) { return; }
      var stage = wrap.querySelector('.gf-stage'), prog = wrap.querySelector('.gf-bars');
      if (!stage) return;
      var ans = {};
      function bars(step) {
        if (!prog) return;
        var h = ''; for (var k = 0; k < 3; k++) h += '<i class="' + (k < step ? 'on' : '') + '"></i>';
        prog.innerHTML = h + '<span class="lbl">' + (step > 3 ? cfg.sonucEtiket : '0' + step + ' / 03') + '</span>';
      }
      function panel(html) {
        var old = stage.querySelector('.gf-panel');
        function put() {
          stage.innerHTML = '<div class="gf-panel">' + html + '</div>';
          var p = stage.firstChild;
          requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('on'); }); });
        }
        if (old && old.classList.contains('on')) { old.classList.add('bye'); old.classList.remove('on'); setTimeout(put, 270); } else put();
      }
      function step(i) {
        var s = cfg.sorular[i]; bars(i + 1);
        var h = '<div class="gf-num">0' + (i + 1) + '</div><h3 class="gf-q">' + s.q + '</h3><span class="gf-qsub">' + s.sub + '</span><div class="gf-opts">';
        s.opts.forEach(function (o, k) { h += '<button class="gf-opt" data-i="' + i + '" data-v="' + o[0] + '"><span class="ix">' + String.fromCharCode(65 + k) + '</span><span class="tx"><span class="lb">' + o[1] + '</span><span class="ds">' + o[2] + '</span></span><span class="ar">→</span></button>'; });
        h += '</div>';
        if (i > 0) h += '<button class="gf-back" data-i="' + (i - 1) + '">← ' + cfg.geriEtiket + '</button>';
        panel(h);
      }
      function result() {
        bars(4);
        function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = (Math.random() * (i + 1)) | 0, t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
        var pool = gifts.filter(function (p) { return p.tur.indexOf(ans.tur) > -1; });
        if (!pool.length) pool = gifts.slice();
        var hard = shuffle(pool.filter(function (p) { return p.kime.indexOf(ans.kime) > -1 && p.tarz.indexOf(ans.tarz) > -1; }));
        var semi = shuffle(pool.filter(function (p) { return hard.indexOf(p) < 0 && (p.kime.indexOf(ans.kime) > -1 || p.tarz.indexOf(ans.tarz) > -1); }));
        var rest = shuffle(pool.filter(function (p) { return hard.indexOf(p) < 0 && semi.indexOf(p) < 0; }));
        var out = hard.concat(semi).concat(rest);
        var seen = {}, uniq = [];
        out.forEach(function (p) { var k = p.url || p.nm; if (!seen[k]) { seen[k] = 1; uniq.push(p); } });
        out = uniq.slice(0, 3);
        function why(p) {
          if (p.kime.indexOf(ans.kime) > -1 && p.tarz.indexOf(ans.tarz) > -1) return cfg.tamIsabet;
          if (p.kime.indexOf(ans.kime) > -1 || p.tarz.indexOf(ans.tarz) > -1) return cfg.uygun;
          return cfg.oneri;
        }
        var h = '<h3 class="gf-q">' + cfg.sonucBaslik.replace('{n}', out.length) + '</h3><span class="gf-qsub">' + cfg.sonucAlt + '</span>'
          + '<div class="gf-sum"><button class="gf-back" id="pdGfRestart" style="margin-left:auto">↺ ' + cfg.bastanEtiket + '</button></div><div class="gf-res">';
        out.forEach(function (p) {
          h += '<a class="gfc" href="' + (p.url || '#') + '"><span class="gfc-ph"><img src="' + p.img + '" alt="' + p.nm + '" loading="lazy"></span>'
            + '<span class="gfc-cap"><span class="nm">' + p.nm + '</span><span class="sub">' + (p.sub || '') + '</span><span class="pr">' + p.pr + '</span><span class="why">✦ ' + why(p) + '</span></span><span class="go">→</span></a>';
        });
        h += '</div>';
        panel(h);
      }
      stage.addEventListener('click', function (e) {
        var o = e.target.closest('.gf-opt');
        if (o) {
          var i = +o.dataset.i; ans[cfg.sorular[i].key] = o.dataset.v;
          if (i < 2) step(i + 1);
          else { panel('<div class="gf-wait"><span>✦</span></div>'); setTimeout(result, 700); }
          return;
        }
        var b = e.target.closest('.gf-back');
        if (b) { if (b.id === 'pdGfRestart') { ans = {}; step(0); } else step(+b.dataset.i); }
      });
      step(0);
    });
  }

  /* ---------- Mıknatıslı butonlar ---------- */
  function initBtns(scope) {
    if (!hasGsap || reduce || coarse) return;
    (scope || document).querySelectorAll('.pd-btn').forEach(function (b) {
      if (!once(b, 'pdMag')) return;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        gsap.to(b, { x: (e.clientX - (r.left + r.width / 2)) * 0.12, y: (e.clientY - (r.top + r.height / 2)) * 0.2, duration: 0.35, ease: 'power3.out' });
      });
      b.addEventListener('mouseleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.45, ease: 'power3.out' }); });
    });
  }

  /* ---------- Dikiş ayraçları ---------- */
  function initStitch(scope) {
    if (!hasGsap || reduce) return;
    (scope || document).querySelectorAll('.pd-stitch').forEach(function (st) {
      if (!once(st, 'pdInit')) return;
      gsap.from(st, { scaleX: 0.55, autoAlpha: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: st, start: 'top 94%', once: true } });
    });
  }

  function init(scope) {
    globalOverlay();
    reveal(scope);
    initHero(scope);
    initKemer(scope);
    initVitrin(scope);
    initImza(scope);
    initSatir(scope);
    initAlinti(scope);
    initKombin(scope);
    initHediye(scope);
    initBtns(scope);
    initStitch(scope);
    if (hasGsap) ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  addEventListener('load', function () { if (hasGsap) ScrollTrigger.refresh(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* HEADER: alt menü — ince işaretçide kalıcı açık; görünürlük saf CSS :hover (titreme imkânsız) */
(function () {
  'use strict';
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function bind(scope) {
    (scope || document).querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.pdCss) return; d.dataset.pdCss = '1';
      d.setAttribute('open', '');
      var hm = d.closest('header-menu');
      if (hm) hm.close = function () {}; /* Dawn'in focusout kapatmasi devre disi */
      var summary = d.querySelector('summary');
      if (summary) summary.addEventListener('click', function (e) {
        e.preventDefault(); /* details toggle'i engelle (panel :hover ile acilir) */
        var url = summary.getAttribute('data-pd-url');
        if (url && url !== '#' && url !== '') window.location.href = url;
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

/* Renk seçici: hover'da renk adını göster */
(function(){
  function init(){
    document.querySelectorAll('[data-pd-renk]').forEach(function(box){
      if(box.dataset.pdRenkOk) return; box.dataset.pdRenkOk='1';
      var ad=box.querySelector('[data-pd-renk-ad]');
      if(!ad) return;
      var asil=ad.textContent;
      box.querySelectorAll('.pr-sw').forEach(function(sw){
        sw.addEventListener('mouseenter',function(){ad.textContent=sw.dataset.renk;});
        sw.addEventListener('mouseleave',function(){ad.textContent=asil;});
      });
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

/* ============================================================
   FAVORİLER — hesapsız, tarayıcıda saklanır (localStorage)
   ============================================================ */
(function(){
  var KEY='pd_fav';
  function oku(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function yaz(l){ try{ localStorage.setItem(KEY, JSON.stringify(l)); }catch(e){} }
  function sayacGuncelle(){
    var n=oku().length;
    document.querySelectorAll('[data-pd-fav-count]').forEach(function(el){
      var ic=el.querySelector('span[aria-hidden]');
      (ic||el).textContent=n; el.hidden=(n===0);
    });
    document.querySelectorAll('[data-pd-fav-link]').forEach(function(el){
      el.classList.toggle('has-fav', n>0);
    });
  }
  function butonGuncelle(){
    var l=oku();
    document.querySelectorAll('[data-pd-fav]').forEach(function(b){
      var on=l.indexOf(String(b.dataset.pdFav))>-1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on?'true':'false');
      b.setAttribute('aria-label', on?'Favorilerden çıkar':'Favorilere ekle');
    });
  }
  function init(){
    document.querySelectorAll('[data-pd-fav]').forEach(function(b){
      if(b.dataset.pdFavOk) return; b.dataset.pdFavOk='1';
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var id=String(b.dataset.pdFav), l=oku(), i=l.indexOf(id);
        if(i>-1){ l.splice(i,1); } else { l.push(id); b.classList.add('pop'); setTimeout(function(){b.classList.remove('pop');},420); }
        yaz(l); butonGuncelle(); sayacGuncelle();
      });
    });
    butonGuncelle(); sayacGuncelle();
    // favoriler sayfasi: kayitli olmayanlari gizle
    var kutu=document.querySelector('[data-pd-fav-page]');
    if(kutu){
      var l=oku(), gorunen=0;
      kutu.querySelectorAll('[data-fav-item]').forEach(function(k){
        var on=l.indexOf(String(k.dataset.favItem))>-1;
        k.hidden=!on; if(on) gorunen++;
      });
      var bos=document.querySelector('[data-pd-fav-empty]');
      if(bos) bos.hidden=(gorunen>0);
      var izgara=kutu.querySelector('[data-fav-grid]');
      if(izgara) izgara.hidden=(gorunen===0);
    }
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', function(e){ if(e.key===KEY){ butonGuncelle(); sayacGuncelle(); } });
})();

/* Hızlı ekle butonunu kare tuvalin içine taşı -> köşeye piksel-tam oturur */
(function(){
  function tasi(){
    document.querySelectorAll('.card-wrapper .quick-add').forEach(function(q){
      var card=q.closest('.card'); if(!card) return;
      var inner=card.querySelector('.card__inner');
      if(inner && q.parentElement!==inner) inner.appendChild(q);
    });
  }
  if(document.readyState!=='loading') tasi(); else document.addEventListener('DOMContentLoaded',tasi);
  document.addEventListener('shopify:section:load',tasi);
})();

/* Beden Seç pop-up'ı kapanınca odak butonda kalıp şeridi takılı bırakmasın */
(function(){
  function izle(){
    document.querySelectorAll('quick-add-modal').forEach(function(m){
      if(m.dataset.pdBlurOk) return; m.dataset.pdBlurOk='1';
      new MutationObserver(function(muts){
        muts.forEach(function(mu){
          if(mu.attributeName==='open' && !m.hasAttribute('open')){
            setTimeout(function(){
              var a=document.activeElement;
              if(a && a.closest && a.closest('.quick-add')) a.blur();
            }, 60);
            var w=m.closest('.card-wrapper');
            if(w && !w.dataset.pdSuskun){
              w.dataset.pdSuskun='1';
              w.classList.add('pd-qa-suskun');
              w.addEventListener('mouseleave', function h(){
                w.classList.remove('pd-qa-suskun');
                delete w.dataset.pdSuskun;
                w.removeEventListener('mouseleave', h);
              });
            }
          }
        });
      }).observe(m,{attributes:true,attributeFilter:['open']});
    });
  }
  if(document.readyState!=='loading') izle(); else document.addEventListener('DOMContentLoaded',izle);
  document.addEventListener('shopify:section:load',izle);
})();

/* Beden Seç kapanışını yakala.
   NOT: quick-add-modal açılınca body'ye taşınıyor — kartla bağı
   modalın id'si üzerinden (modal-opener[data-modal]) kurulur. */
window.__pdSuskunV=3;
(function(){
  function sessize(w){
    if(!w || w.dataset.pdSuskun) return;
    w.dataset.pdSuskun='1';
    w.classList.add('pd-qa-suskun');
    w.addEventListener('mouseleave', function h(){
      w.classList.remove('pd-qa-suskun');
      delete w.dataset.pdSuskun;
      w.removeEventListener('mouseleave', h);
    });
  }
  function modaldanKart(m){
    if(!m) return null;
    var w=m.closest('.card-wrapper');
    if(w) return w;
    if(m.id){
      var op=document.querySelector('modal-opener[data-modal="#'+m.id+'"]');
      if(op) return op.closest('.card-wrapper');
    }
    return window.__pdSonKart||null;
  }
  document.addEventListener('click', function(e){
    var o=e.target && e.target.closest ? e.target.closest('.quick-add__submit') : null;
    if(o) window.__pdSonKart=o.closest('.card-wrapper');
    var t=e.target && e.target.closest ? e.target.closest('.quick-add-modal__toggle') : null;
    if(t) sessize(modaldanKart(t.closest('quick-add-modal')));
  }, true);
  document.addEventListener('keyup', function(e){
    if(e.key==='Escape') sessize(window.__pdSonKart);
  });
})();


/* ============================================================
   PERDAH - Urun sayfasi (pu-)  ·  galeri, beden, kemer cizimi
   ============================================================ */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Kontrolleri (galeri + beden + fiyat) verilen kok icinde bagla.
     Kok: sayfadaki product-info YA DA hizli-ekle modalindaki klonu. */
  function kontrolBagla(root) {
    if (!root || root.dataset.puKtrl) return; root.dataset.puKtrl = '1';
    var variants = [];
    var vJson = root.querySelector('[data-pu-variants]') || document.querySelector('[data-pu-variants]');
    try { variants = JSON.parse(vJson.textContent); } catch (e) { variants = []; }
    var atcLabelEl = root.querySelector('[data-pu-atc-label]') || document.querySelector('[data-pu-atc-label]');
    var soldLabelEl = root.querySelector('[data-pu-soldout-label]') || document.querySelector('[data-pu-soldout-label]');
    var atcLabel = atcLabelEl ? atcLabelEl.textContent.trim() : 'Sepete ekle';
    var soldLabel = soldLabelEl ? soldLabelEl.textContent.trim() : 'Tukendi';

    var main = root.querySelector('[data-pu-main]');
    var kucukler = [].slice.call(root.querySelectorAll('[data-pu-thumbs] .pu-ft'));
    function gorselSec(i) {
      if (!kucukler.length) return;
      i = (i + kucukler.length) % kucukler.length;
      kucukler.forEach(function (x, j) { x.classList.toggle('is-on', j === i); });
      if (main) { main.removeAttribute('srcset'); main.src = kucukler[i].dataset.full; }
      root.dataset.puIdx = i;
    }
    kucukler.forEach(function (t, i) {
      t.addEventListener('click', function () { gorselSec(i); });
    });
    var geri = root.querySelector('[data-pu-prev]');
    var ileri = root.querySelector('[data-pu-next]');
    function idx() { return parseInt(root.dataset.puIdx || '0', 10); }
    if (geri) geri.addEventListener('click', function () { gorselSec(idx() - 1); });
    if (ileri) ileri.addEventListener('click', function () { gorselSec(idx() + 1); });
    var plate = root.querySelector('.pu-plate');
    if (plate && kucukler.length > 1) {
      var _sx = 0, _sy = 0, _st = 0;
      plate.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; _sx = t.clientX; _sy = t.clientY; _st = Date.now();
      }, { passive: true });
      plate.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0], dx = t.clientX - _sx, dy = t.clientY - _sy;
        if (Date.now() - _st < 600 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          gorselSec(idx() + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    var vidInput = root.querySelector('[data-pu-vid]');
    var priceEls = root.querySelectorAll('[data-pu-price]');
    var compEl = root.querySelector('[data-pu-compare]');
    var atcBtn = root.querySelector('[data-pu-atc]');
    var atcTxt = root.querySelector('[data-pu-atc-text]');
    var kok = root.closest('[data-pd-urun]');
    var atcMirror = kok ? kok.querySelector('[data-pu-atc-mirror]') : null;
    var seciliEl = root.querySelector('[data-pu-secili]');
    var stokEl = root.querySelector('[data-pu-stok]');
    function uygula(v) {
      if (!v) return;
      if (vidInput) vidInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = v.price; });
      if (compEl) { compEl.textContent = v.compare || ''; compEl.hidden = !v.compare; }
      if (seciliEl) seciliEl.textContent = v.title;
      if (stokEl) stokEl.hidden = !v.available;
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcTxt) atcTxt.textContent = v.available ? atcLabel + ' — ' + v.price : soldLabel;
      }
      if (atcMirror) { atcMirror.disabled = !v.available; atcMirror.textContent = v.available ? atcLabel : soldLabel; }
    }
    root.querySelectorAll('[data-pu-sizes] .pu-sz-b').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variants.filter(function (x) { return String(x.id) === b.dataset.vid; })[0];
        if (!v) return;
        root.querySelectorAll('[data-pu-sizes] .pu-sz-b').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
        uygula(v);
      });
    });
    var sels = root.querySelectorAll('[data-pu-opt]');
    if (sels.length) {
      var selUygula = function () {
        var secim = [];
        sels.forEach(function (s) { secim[parseInt(s.dataset.puOpt, 10)] = s.value; });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === secim[i]; });
        })[0];
        uygula(v);
      };
      sels.forEach(function (s) { s.addEventListener('change', selUygula); });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pd-urun]').forEach(function (sec) {
      if (sec.dataset.puInit) return; sec.dataset.puInit = '1';
      var hasGsap = !!(window.gsap && window.ScrollTrigger) && !reduce;

      kontrolBagla(sec.querySelector('product-info') || sec);
      var main = sec.querySelector('[data-pu-main]');
      var atcBtn = sec.querySelector('[data-pu-atc]');
      var atcMirror = sec.querySelector('[data-pu-atc-mirror]');

      /* --- cizimler --- */
      var belt = sec.querySelector('[data-pu-draw]');
      if (belt && hasGsap) {
        var strokes = belt.querySelectorAll('rect,line,path,circle');
        strokes.forEach(function (el) {
          var len = 300;
          try { len = el.getTotalLength(); } catch (e) {}
          el.style.strokeDasharray = len; el.style.strokeDashoffset = len;
        });
        gsap.to(strokes, { strokeDashoffset: 0, duration: 1.6, stagger: 0.12, ease: 'power2.out',
          scrollTrigger: { trigger: belt, start: 'top 85%', once: true } });
      }
      var ticks = sec.querySelectorAll('.pu-box svg path');
      if (ticks.length && hasGsap) {
        ticks.forEach(function (p) {
          var len = 30;
          try { len = p.getTotalLength(); } catch (e) {}
          p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
        });
        gsap.to(ticks, { strokeDashoffset: 0, duration: 0.5, stagger: 0.14, ease: 'power2.out',
          scrollTrigger: { trigger: sec.querySelector('.pu-check'), start: 'top 78%', once: true } });
      }
      if (sec.querySelector('.pu-stamp') && hasGsap) {
        gsap.from(sec.querySelector('.pu-stamp'), { scale: 1.5, autoAlpha: 0, rotate: -12, duration: 0.7, ease: 'back.out(1.6)', delay: 0.35 });
      }

      /* --- mobil sabit satın alma çubuğu --- */
      var sticky = sec.querySelector('[data-pu-sticky]');
      if (sticky && atcBtn) {
        if (atcMirror) atcMirror.addEventListener('click', function () { atcBtn.click(); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            // atc butonu ekrandan yukarı kaybolunca çubuğu göster
            var e = es[0];
            var altta = e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', !e.isIntersecting && altta);
          }, { threshold: 0 }).observe(atcBtn);
        }
      }

      /* --- geç yüklenen görsellerden sonra scroll'u tazele (Lenis dead-zone fix) --- */
      if (hasGsap) {
        var refresh = function () { try { ScrollTrigger.refresh(); if (window.__pdLenis) window.__pdLenis.resize(); } catch (e) {} };
        if (main && !main.complete) main.addEventListener('load', refresh, { once: true });
        window.addEventListener('load', refresh, { once: true });
        setTimeout(refresh, 400);
      }
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* hizli-ekle modali: klon yerlesince kontrolleri ona da bagla.
     Koleksiyonda product-info.js yuklu degil -> event yok; MutationObserver sart. */
  document.addEventListener('product-info:loaded', function (e) {
    var pi = e.target;
    if (pi && pi.classList && pi.classList.contains('pu-info')) kontrolBagla(pi);
  });
  function modalIzle(scope) {
    (scope || document).querySelectorAll('quick-add-modal').forEach(function (m) {
      if (m.dataset.puIzle) return; m.dataset.puIzle = '1';
      new MutationObserver(function () {
        var pi = m.querySelector('.pu-info');
        if (pi) kontrolBagla(pi);
      }).observe(m, { childList: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') modalIzle(); else document.addEventListener('DOMContentLoaded', function () { modalIzle(); });
  document.addEventListener('shopify:section:load', function (e) { modalIzle(e.target); });
})();

/* PERDAH - beden rehberi modali */
(function () {
  'use strict';
  function init(scope) {
    (scope || document).querySelectorAll('[data-pd-urun]').forEach(function (sec) {
      if (sec.dataset.puBedenInit) return; sec.dataset.puBedenInit = '1';
      var modal = sec.querySelector('[data-pu-beden-modal]');
      var ac = sec.querySelector('[data-pu-beden-ac]');
      if (!modal || !ac) return;
      /* modalı body'ye taşı — reveal transform'lu ata konteynerden çık,
         böylece position:fixed viewport'a göre ortalanır */
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      var kapat = modal.querySelector('[data-pu-beden-kapat]');
      function acFn() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (window.__pdLenis) window.__pdLenis.stop();
        kapat.focus();
      }
      function kapatFn() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (window.__pdLenis) window.__pdLenis.start();
        ac.focus();
      }
      ac.addEventListener('click', acFn);
      kapat.addEventListener('click', kapatFn);
      modal.addEventListener('click', function (e) { if (e.target === modal) kapatFn(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) kapatFn(); });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* PERDAH - şık imleç takipçisi: tüm sayfalarda (halka + nokta + tık nabzı) */
(function () {
  'use strict';
  if (matchMedia('(pointer: coarse)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.gsap) return;

  var ring = document.createElement('div'); ring.className = 'pu-cursor';
  var dot = document.createElement('div'); dot.className = 'pu-cursor-dot';
  document.body.appendChild(ring); document.body.appendChild(dot);

  var rx = gsap.quickTo(ring, 'x', { duration: 0.5, ease: 'power3' });
  var ry = gsap.quickTo(ring, 'y', { duration: 0.5, ease: 'power3' });
  var dx = gsap.quickTo(dot, 'x', { duration: 0.12, ease: 'power3' });
  var dy = gsap.quickTo(dot, 'y', { duration: 0.12, ease: 'power3' });
  var donme = gsap.to(ring, { rotation: 360, duration: 16, repeat: -1, ease: 'none', paused: true });
  var live = false;
  var hot = '.pu-sz-b,.pu-ft,.pu-atc,.pu-beden-ac,.pu-modal-kapat,.pr-sw,.pu-gi,.card-wrapper,.hp,.xp,.mp,.gfc,.fc,a,button,summary,input,select,label';

  addEventListener('mousemove', function (e) {
    if (!live) { live = true; ring.classList.add('is-live'); dot.classList.add('is-live'); donme.play(); }
    rx(e.clientX); ry(e.clientY); dx(e.clientX); dy(e.clientY);
    var sicak = !!(e.target.closest && e.target.closest(hot));
    ring.classList.toggle('is-hot', sicak);
    donme.timeScale(sicak ? 3 : 1);
  }, { passive: true });
  addEventListener('mouseleave', function () { live = false; ring.classList.remove('is-live'); dot.classList.remove('is-live'); donme.pause(); });
  addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' || !live) return;
    gsap.fromTo(ring, { scale: 0.72 }, { scale: 1, duration: 0.5, ease: 'back.out(2.4)', overwrite: 'auto' });
    gsap.fromTo(dot, { scale: 2.2 }, { scale: 1, duration: 0.4, ease: 'power2.out', overwrite: 'auto' });
  }, { passive: true });
})();

/* PERDAH - sayfa sonradan uzayınca (öneri ürünleri AJAX, geç görseller)
   Lenis scroll limitini ve ScrollTrigger konumlarını tazele.
   Aksi hâlde tekerlek eski sınırda takılır — "alta inmiyor" hatası. */
(function () {
  'use strict';
  var sonH = 0, deb = null;
  function tazele() {
    var h = document.body.scrollHeight;
    if (Math.abs(h - sonH) < 4) return;
    sonH = h;
    try { if (window.__pdLenis && window.__pdLenis.resize) window.__pdLenis.resize(); } catch (e) {}
    try { if (window.ScrollTrigger) ScrollTrigger.refresh(); } catch (e) {}
  }
  function iste() { clearTimeout(deb); deb = setTimeout(tazele, 200); }
  if ('ResizeObserver' in window) new ResizeObserver(iste).observe(document.body);
  document.addEventListener('shopify:section:load', iste);
  window.addEventListener('load', iste);
  setTimeout(iste, 1200); setTimeout(iste, 3000);
  /* öneri ürünleri enjekte olduğu an yakala */
  function izle() {
    document.querySelectorAll('product-recommendations, complementary-products').forEach(function (el) {
      if (el.dataset.pdIzle) return; el.dataset.pdIzle = '1';
      new MutationObserver(iste).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') izle(); else document.addEventListener('DOMContentLoaded', izle);
  document.addEventListener('shopify:section:load', izle);
})();

/* PERDAH - koleksiyon ızgarası: kartlar sırayla belirir; filtre/sıralama
   AJAX ile ızgarayı yenileyince animasyon yeni kartlara yeniden bağlanır. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ciz() {
    if (!window.gsap || reduce) return;
    document.querySelectorAll('[data-pk-draw]').forEach(function (svg) {
      if (svg.dataset.pkCizildi) return; svg.dataset.pkCizildi = '1';
      var strokes = svg.querySelectorAll('path,line,rect,circle');
      strokes.forEach(function (el) {
        var len = 300;
        try { len = el.getTotalLength(); } catch (e) {}
        el.style.strokeDasharray = len; el.style.strokeDashoffset = len;
      });
      var ayar = { strokeDashoffset: 0, duration: 1.5, stagger: 0.1, ease: 'power2.out', delay: 0.2 };
      if (window.ScrollTrigger) ayar.scrollTrigger = { trigger: svg, start: 'top 90%', once: true };
      gsap.to(strokes, ayar);
    });
  }
  function canlandir() {
    ciz();
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (!window.gsap || !window.ScrollTrigger || reduce) return;
    grid.querySelectorAll('.grid__item').forEach(function (it, i) {
      if (it.dataset.pkRv) return; it.dataset.pkRv = '1';
      gsap.from(it, {
        y: 34, autoAlpha: 0, duration: 0.75, ease: 'power3.out',
        delay: (i % 4) * 0.07,
        scrollTrigger: { trigger: it, start: 'top 94%', once: true }
      });
    });
  }
  function bagla() {
    var kap = document.getElementById('ProductGridContainer');
    if (kap && !kap.dataset.pkIzle) {
      kap.dataset.pkIzle = '1';
      new MutationObserver(function () { setTimeout(canlandir, 60); }).observe(kap, { childList: true, subtree: true });
    }
    canlandir();
  }
  if (document.readyState !== 'loading') bagla(); else document.addEventListener('DOMContentLoaded', bagla);
  document.addEventListener('shopify:section:load', bagla);
})();

/* PERDAH - transparent header: ilk açılış şeffaf, aşağı kaydırınca kağıt zemin.
   Dawn'ın scrolled-past-header'ı Lenis ile tetiklenmediğinden kendi bayrağımız. */
(function () {
  'use strict';
  var sh = document.querySelector('.section-header');
  if (!sh) return;
  var esik = 40, acik = false;
  function kontrol() {
    var y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    var v = y > esik;
    if (v === acik) return;
    acik = v;
    sh.classList.toggle('pd-scrolled', v);
  }
  if (window.__pdLenis && window.__pdLenis.on) window.__pdLenis.on('scroll', kontrol);
  window.addEventListener('scroll', kontrol, { passive: true });
  kontrol();
})();
